/**
 * WorkflowExecutionsPage - Submenu "Execuções" do módulo Workflow
 * -----------------------------------------------------------------------------
 * Reaproveita integralmente o painel `WorkflowExecutionsDialog` em modo página
 * (`asPage`): indicadores, filtros, lista paginada e linha do tempo com
 * entrada/saída de cada bloco. Acrescenta o atalho "Abrir registro".
 *
 * Permissão: `workflow_executions` (ver). O banco revalida o tenant.
 *
 * @version 1.0.0
 * RELEASE: 2026-10-06 v1.0.0 - Criação inicial (submenus do Workflow).
 */

import { useSearchParams } from 'react-router-dom';
import { ListPageContent, ListPageHeader, ListPageLayout } from '@/components/layout/list-page';
import { WorkflowExecutionsDialog } from '@/components/workflow/WorkflowExecutionsDialog';
import { useWorkflowRecordOpener } from '@/components/workflow/WorkflowRecordOpener';

export default function WorkflowExecutionsPage() {
  const [params] = useSearchParams();
  const { openRecord, element: fichas } = useWorkflowRecordOpener();

  return (
    <ListPageLayout>
      <ListPageHeader
        title="Execuções do processo"
        description="Acompanhe tudo que já rodou nos seus processos, bloco a bloco."
      />
      <ListPageContent>
        <div className="p-3">
          <WorkflowExecutionsDialog
            asPage
            open
            onOpenChange={() => undefined}
            statusInicial={params.get('status') || 'todos'}
            periodoInicial={params.get('periodo') || 'todos'}
            onOpenRecord={(tipo, id) => openRecord(tipo, id)}
            // BR-WF-EXEC-001: reexecução manual só nesta página (acesso de gestor)
            allowRetryStep
          />
        </div>
      </ListPageContent>
      {fichas}
    </ListPageLayout>
  );
}
